/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import './ImageThumbnailList.css'

const ImageThumbnailList = ({
  entryImages,
  exitImages,
  onSelect,
  activeId,
}) => {
  const renderGroup = (label, images) => (
    <div className="thumbnail-group">
      <div className="group-label">{label}</div>
      <div className="thumbnail-list">
        {images.map((img) => (
          <img
            key={img?.id}
            src={img?.url}
            alt={img?.id}
            className={`thumbnail ${activeId === img?.id ? 'active' : ''}`}
            onClick={() => onSelect(img?.id)}
          />
        ))}
      </div>
    </div>
  )

  return (
    <div className="thumbnail-sidebar">
      {renderGroup('Entry', entryImages)}
      <div className="horizontal-separator" aria-hidden="true"></div>
      {renderGroup('Exit', exitImages)}
    </div>
  )
}

export default ImageThumbnailList
